/** Derive skill name from personalized topic titles created by the API (`Learning: {skill}`). */
export function skillNameFromLearningTopicTitle(title: string): string | null {
  const m = title.match(/^Learning:\s*(.+)$/i)
  const s = m?.[1]?.trim()
  return s && s.length > 0 ? s : null
}

export function failedTopicRecoveryKey(
  skillName: string,
  jobPostingId: number | null | undefined,
): string {
  const jp = jobPostingId == null ? 'general' : String(jobPostingId)
  return `${skillName.trim().toLowerCase()}|${jp}`
}
